import CostItemDetails from "./CostItemDetails";

export default CostItemDetails;
